import { TransactionSuccessToast } from "@/components";
import { type TokenId, type TransactionHash, TOKEN_IDS } from "@/types";
import { ToastDetailRow } from "@/components";

interface DepositSuccessToastProps {
    depositAmount: number;
    depositTokenId: TokenId;
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function DepositSuccessToast({
    depositAmount,
    depositTokenId,
    transactionHash,
    onClose,
}: DepositSuccessToastProps) {
    const isDirectStake = depositTokenId === TOKEN_IDS.IUSD;

    return (
        <TransactionSuccessToast title="Deposit successful" transactionHash={transactionHash} onClose={onClose}>
            {!isDirectStake && <ToastDetailRow label="Minted" amount={depositAmount} tokenId={depositTokenId} />}
            <ToastDetailRow label="Staked" amount={depositAmount} tokenId={TOKEN_IDS.IUSD} />
        </TransactionSuccessToast>
    );
}
